<div class="rounded-md border border-slate-700 bg-slate-800/40 p-2">
  <div class="mb-1 text-xs font-semibold text-slate-200">{{ view().title || 'PnL summary' }}</div>
  <dl class="grid grid-cols-3 gap-2 text-xs">
    <div>
      <dt class="text-slate-400">Realized</dt>
      <dd class="font-mono text-slate-100">{{ view().realized }}</dd>
    </div>
    <div>
      <dt class="text-slate-400">Unrealized</dt>
      <dd class="font-mono text-slate-100">{{ view().unrealized }}</dd>
    </div>
    <div>
      <dt class="text-slate-400">Total</dt>
      <dd class="font-mono text-slate-100">{{ view().total }}</dd>
    </div>
  </dl>
  @if (view().currency) {
    <div class="mt-1 text-mini text-slate-500">Currency: {{ view().currency }}</div>
  }
</div>
